<template>
  <div id="outer-empfehlung">
    <div id="left-uebersicht-empfehlung">
      <UebersichtEingaben id="uebersicht-empfehlung"></UebersichtEingaben>
      <UebersichtDiagnoseComponent id="uebersicht-diagnose-empfehlung"></UebersichtDiagnoseComponent>
    </div>
    <EmpfehlungComponent id="empfehlung-therapie" ></EmpfehlungComponent>
    <div id="pdf-drucken">
      <b-button disabled variant="outline-primary" v-on:click="printPDF">PDF-Übersicht erzeugen <b-icon-file-earmark-text/> </b-button>
    </div>
  </div>
</template>

<script>
import UebersichtEingaben from "../diagnose/UebersichtEingabenComponent";
import UebersichtDiagnoseComponent from "./UebersichtDiagnoseComponent";
import EmpfehlungComponent from "./EmpfehlungComponent";
import {mapGetters} from "vuex";

export default {
  name: "EmpfehlungRoot",
  components: {EmpfehlungComponent, UebersichtDiagnoseComponent, UebersichtEingaben},
  computed: {
    ...mapGetters('cdss', [
      'patientId'
    ])
  },
  methods: {
    commitTherapie(therapie) {
      this.$store.commit('cdss/therapie/setErklaerungsText', therapie.erklaerungsText)
      this.$store.commit('cdss/therapie/arzneimittelvorschlaege', therapie.arzneimittelvorschlaege)
      this.$store.commit('cdss/therapie/ausgewaehltesAntiepileptikum', therapie.ausgewaehltesAntiepileptikum)
      this.$store.dispatch('cdss/putPatientData')
    },
    printPDF() {
      this.$store.dispatch("cdss/putPatientData")
          .then(() => this.$store.dispatch('cdss/generatePatientPDF'))
    }
  }
}
</script>

<style scoped>
#outer-empfehlung {
  display: grid;
  grid-template-areas:
      "uebersicht therapie therapie therapie"
      "uebersicht therapie therapie therapie"
      ". . . pdf-drucken";
  grid-template-rows: auto auto 40px;
  grid-template-columns: 3fr 2fr 2fr 2fr;
  height: 100%;
}

#left-uebersicht-empfehlung {
  grid-area: uebersicht;
  grid-template-areas:
      "uebersicht-empfehlung"
      "uebersicht-diagnose-empfehlung";
  grid-template-rows: auto min-content;
  border: solid 1px;
}

#uebersicht-empfehlung {
  grid-area: uebersicht-empfehlung;
}

#uebersicht-diagnose-empfehlung {
  grid-area: uebersicht-diagnose-empfehlung;
}

#empfehlung-therapie {
  grid-area: therapie;
}

#pdf-drucken{
  grid-area: pdf-drucken;
  justify-self: right;
  padding-right: 5px;
}
</style>
